/** Shown after HTTP 409: somebody saved a newer version in the meantime. */
export function ConflictNotice({ onReload }: { onReload: () => void }) {
  return (
    <div className="alert" role="alert">
      <strong>Ktoś już zmienił te dane.</strong> Twoje zmiany nie zostały zapisane.
      <div>
        <button type="button" className="btn small" onClick={onReload}>
          Wczytaj aktualne dane
        </button>
      </div>
    </div>
  );
}
